const defaultSandboxBaseDomain = "dev-ftt-886436961140.com";

const trimSlashes = (value) => value.replace(/^\/+|\/+$/g, "");
const trimTrailingSlash = (value) => value.replace(/\/+$/g, "");

export const sandboxBaseDomain =
    (process.env.REACT_APP_SANDBOX_BASE_DOMAIN || defaultSandboxBaseDomain).trim() || defaultSandboxBaseDomain;

export const getSandboxDomain = (subdomain) => `${subdomain}.${sandboxBaseDomain}`;

export const getSandboxUrl = (subdomain, path = "") => {
    const normalizedPath = trimSlashes(path);
    return `https://${getSandboxDomain(subdomain)}${normalizedPath ? `/${normalizedPath}` : ""}`;
};

export const getConfiguredUrl = (value, fallbackSubdomain, path = "") => {
    const configuredValue = (value || "").trim();
    return configuredValue ? trimTrailingSlash(configuredValue) : getSandboxUrl(fallbackSubdomain, path);
};

export const getUrlDomain = (url) => {
    try {
        return new URL(url).hostname;
    } catch (error) {
        return url.replace(/^https?:\/\//, "").replace(/\/.*$/, "");
    }
};

export const applyServiceBaseUrlToOpenApiSpec = (payload, service) => {
    if (!payload || !service?.baseUrl || !Array.isArray(payload.servers)) {
        return payload;
    }

    return {
        ...payload,
        servers: payload.servers.map((server) => {
            if (!server?.url?.includes("{baseUrl}") || !server.variables?.baseUrl) {
                return server;
            }

            return {
                ...server,
                variables: {
                    ...server.variables,
                    baseUrl: {
                        ...server.variables.baseUrl,
                        default: service.baseUrl,
                    },
                },
            };
        }),
    };
};

export const middlewareUiUrl = getConfiguredUrl(
    process.env.REACT_APP_MIDDLEWARE_UI_URL,
    "demo-middleware"
);

export const nativeSdksUrl = getConfiguredUrl(
    process.env.REACT_APP_NATIVE_SDKS_URL,
    "nativas"
);
